var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('Header',{attrs:{"sidebar":true},on:{"toggleDrawer":_vm.toggleDrawer}}),_c('ProjectDrawer',{ref:"drawer"}),_c('v-main',[_c('v-container',{staticClass:"py-0 pb-3",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }